import { render, staticRenderFns } from "./ProvinceCity.vue?vue&type=template&id=b9c1d6c4&scoped=true&"
import script from "./ProvinceCity.vue?vue&type=script&lang=ts&"
export * from "./ProvinceCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c1d6c4",
  null
  
)

export default component.exports